/**
 * AsyncLocalStorage polyfill for browser environments
 */

// Simple AsyncLocalStorage implementation for browser
class AsyncLocalStoragePolyfill {
  constructor() {
    this.store = null;
  }

  run(store, callback, ...args) {
    const previousStore = this.store;
    this.store = store;
    try {
      return callback(...args);
    } finally {
      this.store = previousStore;
    }
  }

  getStore() {
    return this.store;
  }

  enterWith(store) {
    this.store = store;
  }
}

// Export for both CommonJS and ESM
const AsyncLocalStorage = globalThis.AsyncLocalStorage || AsyncLocalStoragePolyfill;

// Make it available globally
if (!globalThis.AsyncLocalStorage) {
  globalThis.AsyncLocalStorage = AsyncLocalStoragePolyfill;
}

export { AsyncLocalStorage };
export default AsyncLocalStorage;

// CommonJS compatibility
if (typeof module !== 'undefined' && module.exports) {
  module.exports = AsyncLocalStorage;
  module.exports.AsyncLocalStorage = AsyncLocalStorage;
}